export default __webpack_public_path__ + "static/dellemc-81aa0c815c45738491057ac740cc2200.jpg";